/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MinInputs */

const en_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const es_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mín.`)
};

const fr_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const de_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const ja_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小`)
};

const zh_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小`)
};

const ar_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأدنى`)
};

const id_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const it_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const ru_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мин`)
};

const pt_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mín`)
};

const ko_min = /** @type {(inputs: MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최소`)
};

/**
* | output |
* | --- |
* | "Min" |
*
* @param {MinInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const min = /** @type {((inputs?: MinInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MinInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_min(inputs)
	if (locale === "es") return es_min(inputs)
	if (locale === "fr") return fr_min(inputs)
	if (locale === "de") return de_min(inputs)
	if (locale === "ja") return ja_min(inputs)
	if (locale === "zh") return zh_min(inputs)
	if (locale === "ar") return ar_min(inputs)
	if (locale === "id") return id_min(inputs)
	if (locale === "it") return it_min(inputs)
	if (locale === "ru") return ru_min(inputs)
	if (locale === "pt") return pt_min(inputs)
	return ko_min(inputs)
});